import { PayloadAction } from '@reduxjs/toolkit';
import { AbstractProduct, DesignState } from 'src/store/design/types';

const setDesignAbstractProductReducer = (state: DesignState, action: PayloadAction<AbstractProduct|undefined>) => {
  state.abstractProduct = action.payload;
};

export default setDesignAbstractProductReducer;
